import {CHANGE_PAGE} from '../actions/pageAction'

const initial_page = {
    pageName: ''
}

const pageReducer = (state = initial_page, action) => {
    switch (action.type) {
        case CHANGE_PAGE: {
            
            return {
                ...state,
                pageName: action.page
            }
        }
            
    
        default: return state;
    }
}

export default pageReducer